import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";
import pt from "./locales/pt.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      pt: { translation: pt },
    },
    supportedLngs: ["en", "es", "pt"],
    fallbackLng: "en",
    // Always render English on the first paint so it matches the prerendered
    // English snapshot (scripts/prerender.js) → clean hydration, no flash.
    // A previously-chosen language is restored *after* mount (see App.jsx for
    // anonymous visitors; AuthContext for logged-in users), and changeLanguage
    // still caches the choice to localStorage via the detector below.
    lng: "en",
    detection: {
      lookupLocalStorage: "tactics_lang",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
    // Bundled resources are available synchronously, so Suspense is never
    // needed — disabling it keeps hydration simple and predictable.
    react: {
      useSuspense: false,
    },
  });

export default i18n;